import React from 'react'
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined'
import styled from 'styled-components'

import { color } from 'styles/colors'

type Props = {
  className?: string
}

const Icon = ({ className }: Props) => (
  <S.Circle className={className} >
    <SettingsRemoteOutlinedIcon sx={{ fontSize: 16 }} />
  </S.Circle>
)

export default Icon

const S = {
  Circle: styled.div`
    border: 1.5px solid black;
    display: inline-block;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: ${color('iconBackground')};
    padding: 4px;
  `
}
